import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSocket } from "../../helper/socket";

// Async action to emit and listen for bet completion
export const completeBet = createAsyncThunk(
    "betComplete/complete",
    async (dataToSend, { rejectWithValue }) => {
        return new Promise((resolve, reject) => {
            const socket = getSocket();

            try {
                socket.emit("BetComplete", dataToSend); // Emit the event with optional data

                socket.once("BetComplete", (data) => {
                    if (data.success) {
                        resolve(data); // Resolve with success response
                    } else {
                        reject(rejectWithValue(data.message || "Failed to complete bet"));
                    }
                });

                // Optional timeout in case of no response
                setTimeout(() => reject(rejectWithValue("No response from server")), 5000);
            } catch (error) {
                reject(rejectWithValue(error.message));
            }
        });
    }
);

const betCompleteSlice = createSlice({
    name: "betComplete",
    initialState: {
        loading: false,
        success: false,
        message: null,
        error: null,
    },
    reducers: {
        resetBetComplete: (state) => {
            state.loading = false;
            state.success = false;
            state.message = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(completeBet.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.message = null;
                state.error = null;
            })
            .addCase(completeBet.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload.message;
            })
            .addCase(completeBet.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.payload;
            });
    },
});

export const { resetBetComplete } = betCompleteSlice.actions;
export default betCompleteSlice.reducer;
